import { Button, DatePicker, Form, Modal } from 'antd';
import React, { useEffect, useState } from 'react';
import EventEmitter from '../utils/eventEmitter';



const MyFooter = ({ handleSell, handleCancel }) => {
  return (
    <div className='flex border-t-2 pt-2'>
      <Button className='me-3' onClick={handleSell} type='primary'>PAUSE</Button>
      <Button onClick={handleCancel} danger>CANCEL</Button>
    </div>
  )
};


const PauseDepreciation = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();

  
  const handleCancel = () => setIsModalOpen(false);
  
  const handleOk = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
    EventEmitter.subscribe('pause_depreciation', data => setIsModalOpen(data));
    return () => EventEmitter.unsubscribe('pause_depreciation');
  },[])

  return (
    <Modal title="Pause Asset" className='p-0' open={isModalOpen} onOk={handleOk} onCancel={handleCancel} footer={<MyFooter handleCancel={handleCancel} handleSell={handleOk}/>}>
      <Form name="pauseAsset"
        form={form}
        className='border-t-2 py-5' 
        labelAlign='left'
        labelCol={{span: 8}}
        initialValues={{  }}
        autoComplete="off"
        variant='borderless'
      >
        <Form.Item label='Pause date' name="pause_date" className='font-semibold text-gray-800 mb-4' required>
          <DatePicker />
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default PauseDepreciation;